<template>
  <div class="row-block filters">
    <multiselect
      v-model="selectedVacancy"
      class="big"
      :options="vacancies"
      :show-labels="false"
      :allow-empty="true"
      :searchable="true"
      :loading="loading_more"
      open-direction="bottom"
      track-by="id"
      label="name"
      :placeholder="$tr('vacancies.placeholders.selectVacancy')"
      @search-change="asyncFind"
    >
      <template v-if="vacancies_total > vacancies.length" slot="afterList">
        <div class="after-list">
          <vbutton
            :text="$tr('select.button.more')"
            :disabled="loading_more"
            :loading="loading_more"
            @click="load_more"
          />
        </div>
      </template>
    </multiselect>

    <multiselect
      v-model="selectedUser"
      class="big"
      :options="users"
      :show-labels="false"
      :allow-empty="true"
      :searchable="true"
      open-direction="bottom"
      track-by="id"
      :label="!is_japan_locale ? 'full_name' : 'full_name_reverse'"
      :placeholder="$tr('analytics.filters.users')"
    />
  </div>
</template>

<script>
import debounce from 'debounce';
import { orderBy } from 'lodash';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'AnalyticsFiltersSelectors',

  data() {
    return {
      vacanciesArr: [],
      usersArr: [],
      loading_more: false,
      searchTerm: '',
      count: 20
    };
  },

  computed: {
    ...mapState('vacancies', ['vacancies_total', 'list_dropdown']),

    ...mapGetters({
      company: 'company/one',
      is_japan_locale: 'locale/is_japan_locale'
    }),

    vacancies() {
      const label = this.$tr('analytics.filters.vacancy');
      let vacanciesArr = this.list_dropdown;
      let vacancies = [{ id: 0, name: label }, ...vacanciesArr];

      return vacancies;
    },

    selectedVacancy: {
      get() {
        return this.$store.getters['analytics/selectedVacancy'];
      },

      set(val) {
        this.filtersChange({ vacancy: val });
      }
    },

    users() {
      const label = this.$tr('analytics.filters.user');
      const full_name = !this.is_japan_locale ? 'full_name' : 'full_name_reverse';
      let sortArr = orderBy(
        this.usersArr,
        [option => (option.full_name ? option.full_name.toLowerCase() : '')],
        [full_name],
        ['asc']
      );
      let users = [
        {
          email: null,
          id: 'all',
          full_name: label,
          full_name_reverse: label
        },
        ...sortArr
      ];

      return users;
    },

    selectedUser: {
      get() {
        return this.$store.getters['analytics/selectedUser'];
      },

      set(val) {
        this.filtersChange({ user: val });
      }
    }
  },

  beforeMount() {
    this.CHANGE_PAGINATION_COUNT(20);
    this.fetchVacancies();
    this.fetchUsers();
  },

  beforeDestroy() {
    this.CHANGE_PAGINATION_COUNT(20);
  },

  methods: {
    ...mapMutations('vacancies', ['CHANGE_PAGINATION_COUNT']),
    ...mapMutations('analytics', ['filtersChange']),
    ...mapActions('vacancies', ['fetchVacanciesListDropdown']),
    ...mapActions('analytics', { fetchRecruiters: 'fetch' }),

    fetchVacancies() {
      this.loading_more = true;
      let params = {
        searchTerm: this.searchTerm
      };

      this.fetchVacanciesListDropdown(params)
        .then(() => {
          this.loading_more = false;
        })
        .catch(() => {
          this.loading_more = false;
        });
    },

    asyncFind: debounce(function (v) {
      this.searchTerm = v;
      this.fetchVacancies();
      this.fetchRecruiters();
    }, 500),

    load_more(is_active = true) {
      this.count = this.count + 20;
      this.CHANGE_PAGINATION_COUNT(this.count);
      this.fetchVacancies();
    },

    fetchUsers() {
      this.$store
        .dispatch('users/fetchUsersDropdown')
        .then(() => {
          this.usersArr = this.$store.getters['users/listDropdown'];
        })
        .catch(err => {
          this.$store.dispatch('global/setError', err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.multiselect + .multiselect {
  margin-left: 12px;
}

.filters {
  ::v-deep {
    .after-list {
      padding: 10px;
      border-top: 1px solid #ccc;
      margin-top: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .multiselect__spinner {
      width: 28px;
      height: 14px;

      &:before,
      &:after {
        width: 10px;
        height: 10px;
        right: 0px;
      }
    }
  }
}
</style>
